import BaseModal from '@core/components/modals/base-modal/base-modal';
import PredictiveSearch from '@core/components/form/predictive-search/predictive-search';

export default class SearchModal extends BaseModal {
  init() {
    super.init('search-modal');

    const predictiveSearch = new PredictiveSearch('header-search');
    // predictiveSearch.fakeAjaxUrl = 'search-autocomplete';
    predictiveSearch.init();
  }

  get speed() {
    return 100;
  }
}
